// @ts-check
/** @typedef {import('./actionsT.d.ts').UpdateProjectAction} UpdateProjectAction */
/** @typedef {import('./actionsT.d.ts').ResetProjectAction} ResetProjectAction */
/** @typedef {import('./actionsT.d.ts').UpdateCategoryAction} UpdateCategoryAction */
/** @typedef {import('./actionsT.d.ts').ResetCategoryAction} ResetCategoryAction */
/** @typedef {import('./actionsT.d.ts').UpdateModuleAction} UpdateModuleAction */
/** @typedef {import('./actionsT.d.ts').ResetModuleAction} ResetModuleAction */
/** @typedef {import('./actionsT.d.ts').UpdateDateAction} UpdateDateAction */
/** @typedef {import('./actionsT.d.ts').ResetDateAction} ResetDateAction */
/** @typedef {import('./actionsT.d.ts').UpdateCommentAction} UpdateCommentAction */
/** @typedef {import('./actionsT.d.ts').ResetCommentAction} ResetCommentAction */
/** @typedef {import('./actionsT.d.ts').UpdateDeleteClientBilledTimeAction} UpdateDeleteClientBilledTimeAction */
/** @typedef {import('./actionsT.d.ts').ResetDeleteClientBilledTimeAction} ResetDeleteClientBilledTimeAction */
/** @typedef {import('./actionsT.d.ts').UpdateTimeDifferenceCommentAction} UpdateTimeDifferenceCommentAction */
/** @typedef {import('./actionsT.d.ts').ResetTimeDifferenceCommentAction} ResetTimeDifferenceCommentAction */
/** @typedef {import('./actionsT.d.ts').ResetFieldsAction} ResetFieldsAction */
/** @typedef {import('./actionsT.d.ts').SetInitiallySelectedDatesAction} SetInitiallySelectedDatesAction */
/** @typedef {import('./actionsT.d.ts').SetCategoriesLoadingAction} SetCategoriesLoadingAction */
/** @typedef {import('./actionsT.d.ts').SetCategoriesOptionsAction} SetCategoriesOptionsAction */
/** @typedef {import('./actionsT.d.ts').SetCategoryErrorAction} SetCategoryErrorAction */
/** @typedef {import('./actionsT.d.ts').SetIsFetchingModulesAction} SetIsFetchingModulesAction */
/** @typedef {import('./actionsT.d.ts').setFetchedModulesAction} setFetchedModulesAction */
/** @typedef {import('./actionsT.d.ts').SetFetchedModuleErrorAction} SetFetchedModuleErrorAction */
/** @typedef {import('./actionsT.d.ts').SetProjectsLoadingAction} SetProjectsLoadingAction */
/** @typedef {import('./actionsT.d.ts').SetProjectsOptionsAction} SetProjectsOptionsAction */
/** @typedef {import('./actionsT.d.ts').SetProjectsErrorAction} SetProjectsErrorAction */

export const SET_INITIALLY_SELECTED_DATES = "SET_INITIALLY_SELECTED_DATES"

export const UPDATE_DATE = "UPDATE_DATE"
export const RESET_DATE = "RESET_DATE"

export const UPDATE_PROJECT = "UPDATE_PROJECT"
export const RESET_PROJECT = "RESET_PROJECT"

export const UPDATE_CATEGORY = "UPDATE_CATEGORY"
export const RESET_CATEGORY = "RESET_CATEGORY"

export const UPDATE_MODULE = "UPDATE_MODULE"
export const RESET_MODULE = "RESET_MODULE"

export const UPDATE_COMMENT = "UPDATE_COMMENT"
export const RESET_COMMENT = "RESET_COMMENT"

export const UPDATE_BILLED_TIME_REMOVAL = "UPDATE_BILLED_TIME_REMOVAL"
export const RESET_BILLED_TIME_REMOVAL = "RESET_BILLED_TIME_REMOVAL"

export const UPDATE_TIME_DIFFERENCE_COMMENT = "UPDATE_TIME_DIFFERENCE_COMMENT"
export const RESET_TIME_DIFFERENCE_COMMENT = "RESET_TIME_DIFFERENCE_COMMENT"

export const RESET_FIELDS = "RESET_FIELDS"

// Async: Categories
export const SET_CATEGORIES_LOADING = "SET_CATEGORIES_LOADING"
export const SET_CATEGORIES_OPTIONS = "SET_CATEGORIES_OPTIONS"
export const SET_CATEGORY_ERROR = "SET_CATEGORY_ERROR"

// Async: Modules
export const SET_FETCHING_MODULES = "SET_FETCHING_MODULES"
export const SET_FETCHED_MODULES = "SET_FETCHED_MODULES"
export const SET_FETCHING_MODULES_ERROR = "SET_FETCHING_MODULES_ERROR"

// Async: Projects
export const SET_PROJECTS_LOADING = "SET_PROJECTS_LOADING"
export const SET_PROJECTS_OPTIONS = "SET_PROJECTS_OPTIONS"
export const SET_PROJECTS_ERROR = "SET_PROJECTS_ERROR"

// Action Creators

/**
 * @param {string} project
 * @param {boolean} projectUsesSpecialCategories
 * @returns {UpdateProjectAction} */
export const updateProject = (project, projectUsesSpecialCategories) => ({
  type: UPDATE_PROJECT,
  payload: { project, projectUsesSpecialCategories },
})

/** @returns {ResetProjectAction} */
export const resetProject = () => ({ type: RESET_PROJECT })

/** @returns {UpdateCategoryAction} */
export const updateCategory = (category) => ({
  type: UPDATE_CATEGORY,
  payload: { category },
})

/** @returns {ResetCategoryAction} */
export const resetCategory = () => ({ type: RESET_CATEGORY })

/** @returns {UpdateModuleAction} */
export const updateModule = (module) => ({
  type: UPDATE_MODULE,
  payload: { module },
})

/** @returns {ResetModuleAction} */
export const resetModule = () => ({ type: RESET_MODULE })

/** @returns {UpdateDateAction} */
export const updateDate = (date) => ({
  type: UPDATE_DATE,
  payload: { date },
})

/** @returns {ResetDateAction} */
export const resetDate = () => ({ type: RESET_DATE })

/** @returns {UpdateCommentAction} */
export const updateComment = (comment) => ({
  type: UPDATE_COMMENT,
  payload: { comment },
})

/** @returns {ResetCommentAction} */
export const resetComment = () => ({ type: RESET_COMMENT })

/** @returns {UpdateDeleteClientBilledTimeAction} */
export const updateDeleteClientBilledTime = (value) => ({
  type: UPDATE_BILLED_TIME_REMOVAL,
  payload: { value },
})

/** @returns {ResetDeleteClientBilledTimeAction} */
export const resetDeleteClientBilledTime = () => ({
  type: RESET_BILLED_TIME_REMOVAL,
})

/** @returns {UpdateTimeDifferenceCommentAction} */

export const updateTimeDifferenceComment = (comment) => ({
  type: UPDATE_TIME_DIFFERENCE_COMMENT,
  payload: { comment },
})

/** @returns {ResetTimeDifferenceCommentAction} */
export const resetTimeDifferenceComment = () => ({
  type: RESET_TIME_DIFFERENCE_COMMENT,
})

/** @returns {ResetFieldsAction} */
export const resetFields = (
  initiallySelectedProjectsAllHaveSpecialCategories
) => ({
  type: RESET_FIELDS,
  payload: { initiallySelectedProjectsAllHaveSpecialCategories },
})

/** @returns {SetInitiallySelectedDatesAction} */
export const setInitiallySelectedDates = (dates) => ({
  type: SET_INITIALLY_SELECTED_DATES,
  payload: { dates },
})

// Category Async State

/** @returns {SetCategoriesLoadingAction} */
export const setCategoriesLoading = (isLoading) => ({
  type: SET_CATEGORIES_LOADING,
  payload: { isLoading },
})

/** @returns {SetCategoriesOptionsAction} */
export const setCategoriesOptions = (options) => ({
  type: SET_CATEGORIES_OPTIONS,
  payload: { options },
})

/** @returns {SetCategoryErrorAction} */
export const setCategoriesError = (error) => ({
  type: SET_CATEGORY_ERROR,
  payload: { error },
})

// Module Async State

/** @returns {SetIsFetchingModulesAction} */
export const setIsFetchingModules = (isLoading) => ({
  type: SET_FETCHING_MODULES,
  payload: { isLoading },
})

/** @returns {setFetchedModulesAction} */
export const setFetchedModules = (options) => ({
  type: SET_FETCHED_MODULES,
  payload: { options },
})

/** @returns {SetFetchedModuleErrorAction} */
export const setFetchedModulesError = (error) => ({
  type: SET_FETCHING_MODULES_ERROR,
  payload: { error },
})

// Project Async State

/** @returns {SetProjectsLoadingAction} */
export const setProjectsLoading = (isLoading) => ({
  type: SET_PROJECTS_LOADING,
  payload: { isLoading },
})

/** @returns {SetProjectsOptionsAction} */
export const setProjectsOptions = (options) => ({
  type: SET_PROJECTS_OPTIONS,
  payload: { options },
})

/** @returns {SetProjectsErrorAction} */
export const setProjectsError = (error) => ({
  type: SET_PROJECTS_ERROR,
  payload: { error },
})
